import type React from 'react'
import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import {
  DetailsContainer,
  Item,
  SectionHeading,
} from '@/components/DecisionPanelCards/Shared'
import DetailsList from '@/components/DetailsList'
import ExpandableCard from '@/components/ExpandableCard'
import type { Application, EmergencyContact } from '@/types/Activity'

interface Props {
  application: Application
}

const AdditionalInfoItems = styled.div`
  display: flex;
  flex-flow: column wrap;
  width: 100%;
  margin-top: 20px;
`

const Body = styled.div`
  margin-top: 20px;
  transition: height 0.25s ease-in;

  ${Item} h2 {
    margin-top: 0;
  }
`

const toEmergencyContactDetails = (emergencyContact: EmergencyContact | undefined) => {
  if (!emergencyContact) {
    return []
  }

  return [
    { label: 'Name', children: emergencyContact.name },
    { label: 'Relationship', children: emergencyContact.relationship },
    { label: 'Email', children: emergencyContact.email },
    { label: 'Phone', children: emergencyContact.phone },
  ]
}

const AdditionalDetailsCard: React.FC<Props> = ({ application }) => {
  const [additionalData, setAdditionalChecklistInfo] = useState<any[]>([])
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const emergencyContact = application.context?.emergencyContactDetails
  const emergencyContactDetails = useMemo(
    () => toEmergencyContactDetails(emergencyContact),
    [emergencyContact],
  )

  useEffect(() => {
    if (!application || !application?.context) {
      return
    }

    let additionalChecklistData: any[] = []

    const additionalChecklistItems = application?.additionalQuestions?.items

    additionalChecklistData = [{ key: 'Items', value: additionalChecklistItems }]

    setAdditionalChecklistInfo(additionalChecklistData)
  }, [application])

  return (
    <ExpandableCard
      isExpanded={isExpanded}
      handleExpand={() => setIsExpanded(!isExpanded)}
      label="Additional Details"
      icon="additional questions"
      expandedContent={
        <Body>
          {emergencyContactDetails.length > 0 && (
            <>
              <SectionHeading>Emergency Contact</SectionHeading>
              <DetailsContainer>
                <DetailsList details={emergencyContactDetails} />
              </DetailsContainer>
            </>
          )}
          {additionalData.map(({ key, value }, outerIndex) => {
            if (key === 'Items' && value?.length > 0) {
              return (
                <AdditionalInfoItems key={outerIndex}>
                  <SectionHeading>Additional Questions</SectionHeading>
                  <hr />
                  {value.map((checkListItem: any, innerIndex: number) => {
                    return (
                      <Item key={innerIndex}>
                        <h2>
                          {checkListItem.key &&
                          checkListItem.key.toLowerCase() === 'annual income'
                            ? 'Self Declared Income'
                            : checkListItem.key}
                        </h2>
                        <span>
                          {checkListItem.value === 'true'
                            ? 'Yes'
                            : checkListItem.value === 'false'
                              ? 'No'
                              : checkListItem.value}
                        </span>
                      </Item>
                    )
                  })}
                </AdditionalInfoItems>
              )
            }
            return null
          })}
        </Body>
      }
    />
  )
}

export default AdditionalDetailsCard
